export var VALIDITY_STATE;
(function (VALIDITY_STATE) {
    // HTML validity states
    VALIDITY_STATE["BAD_INPUT"] = "badInput";
    VALIDITY_STATE["CUSTOM_ERROR"] = "customError";
    VALIDITY_STATE["PATTERN_MISMATCH"] = "patternMismatch";
    VALIDITY_STATE["RANGE_OVERFLOW"] = "rangeOverflow";
    VALIDITY_STATE["RANGE_UNDERFLOW"] = "rangeUnderflow";
    VALIDITY_STATE["STEP_MISMATCH"] = "stepMismatch";
    VALIDITY_STATE["TOO_LONG"] = "tooLong";
    VALIDITY_STATE["TOO_SHORT"] = "tooShort";
    VALIDITY_STATE["TYPE_MISMATCH"] = "typeMismatch";
    VALIDITY_STATE["VALID"] = "valid";
    VALIDITY_STATE["VALUE_MISSING"] = "valueMissing";
    // sfc custom validity states
    VALIDITY_STATE["DATE_WEEKEND"] = "dateWeekend";
    VALIDITY_STATE["DATE_HOLIDAY"] = "dateHoliday";
    VALIDITY_STATE["DATE_BLOCKED"] = "dateBlocked";
    VALIDITY_STATE["NO_SELECTED_VALUE"] = "noSelectedValue";
})(VALIDITY_STATE || (VALIDITY_STATE = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy92YWxpZGF0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLGNBa0JYO0FBbEJELFdBQVksY0FBYztJQUN6Qix1QkFBdUI7SUFDdkIsd0NBQXNCLENBQUE7SUFDdEIsOENBQTRCLENBQUE7SUFDNUIsc0RBQW9DLENBQUE7SUFDcEMsa0RBQWdDLENBQUE7SUFDaEMsb0RBQWtDLENBQUE7SUFDbEMsZ0RBQThCLENBQUE7SUFDOUIsc0NBQW9CLENBQUE7SUFDcEIsd0NBQXNCLENBQUE7SUFDdEIsZ0RBQThCLENBQUE7SUFDOUIsaUNBQWUsQ0FBQTtJQUNmLGdEQUE4QixDQUFBO0lBQzlCLDZCQUE2QjtJQUM3Qiw4Q0FBNEIsQ0FBQTtJQUM1Qiw4Q0FBNEIsQ0FBQTtJQUM1Qiw4Q0FBNEIsQ0FBQTtJQUM1Qix1REFBcUMsQ0FBQTtBQUN0QyxDQUFDLEVBbEJXLGNBQWMsS0FBZCxjQUFjLFFBa0J6QiJ9